import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';

const RankingPage = () => {
  const navigate = useNavigate();

  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const pageStyle = {
    marginLeft: '260px',
    width: 'calc(100% - 260px)',
    minHeight: '100vh',
    padding: '2rem',
    boxSizing: 'border-box',
  };

  const cardStyle = {
    maxWidth: '1100px',
    margin: '0 auto',
  };

  useEffect(() => {
    const fetchRanking = async () => {
      try {
        const token = localStorage.getItem('token');

        if (!token) {
          setError('Niste prijavljeni. Molimo prijavite se ponovo.');
          navigate('/login');
          return;
        }

        const res = await axios.get('https://nagradjivanje-api.revicon.info/ranking', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log('RANKING DATA:', res.data);

        const rankingData = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data.ranking)
            ? res.data.ranking
            : [];

        setRanking(rankingData);
      } catch (err) {
        console.error('Failed to fetch ranking:', err);
        setError('Greška prilikom učitavanja rang liste.');
      } finally {
        setLoading(false);
      }
    };

    fetchRanking();
  }, [navigate]);

  if (loading) {
    return (
      <div style={pageStyle}>
        <div style={cardStyle}>
          Učitavanje rang liste...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={pageStyle}>
        <div style={cardStyle}>
          <h1 className="text-2xl font-bold mb-4">Rang lista – NEXUS rezultat</h1>
          <p className="text-red-600">{error}</p>

          <div className="mt-4">
            <Link to="/" className="text-blue-600 underline">
              Nazad na početnu
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
          <div>
            <h1 className="text-2xl font-bold">Rang lista – NEXUS rezultat</h1>
            <p className="text-sm text-gray-600 mt-1">
              Pregled ukupnog rezultata po korisniku/JLS.
            </p>
          </div>

          <div className="flex flex-wrap gap-2 text-sm">
            <Link to="/result/1" className="px-3 py-2 border rounded hover:bg-gray-100">
              Rezultat K1
            </Link>
            <Link to="/result/2" className="px-3 py-2 border rounded hover:bg-gray-100">
              Rezultat K2
            </Link>
            <Link to="/result/3" className="px-3 py-2 border rounded hover:bg-gray-100">
              Rezultat K3
            </Link>
            <Link to="/result/4" className="px-3 py-2 border rounded hover:bg-gray-100">
              Rezultat K4
            </Link>
          </div>
        </div>

        {ranking.length === 0 ? (
          <div className="border rounded p-4 bg-gray-50">
            Nema dostupnih podataka za rang listu.
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full border border-gray-300 bg-white">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-2 px-4 border text-center">#</th>
                  <th className="py-2 px-4 border text-left">Naziv</th>
                  <th className="py-2 px-4 border text-left">Email</th>
                  <th className="py-2 px-4 border text-center">Ukupno bodova</th>
                </tr>
              </thead>

              <tbody>
                {ranking.map((row, index) => {
                  const rank = row.rank || index + 1;
                  const totalScore = Number(row.total_score || row.total || row.score || 0);

                  return (
                    <tr key={row.user_id || row.email || index} className="hover:bg-gray-50">
                      <td className="py-2 px-4 border text-center">
                        {rank}
                      </td>

                      <td className="py-2 px-4 border">
                        {row.name || row.municipality_name || 'Nepoznato'}
                      </td>

                      <td className="py-2 px-4 border">
                        {row.email || '-'}
                      </td>

                      <td className="py-2 px-4 border text-center font-semibold">
                        {totalScore.toFixed(2)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        <div className="mt-6 flex flex-wrap gap-3">
          <Link to="/" className="text-blue-600 underline">
            Nazad na početnu
          </Link>

          <Link to="/questionnaire/1" className="text-blue-600 underline">
            Otvori upitnik
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RankingPage;